import { c as _c } from "react/compiler-runtime";
import type { Offer } from "@local/offer/src/types";
import { cn } from "@local/utils/src/cn";
import { getCdnUrl } from "@local/utils/src/getCdnUrl";
interface Props {
  name: string;
  size: "xs" | "sm" | "md" | "lg";
  image?: Offer.BlockMedia;
}
export const Avatar = t0 => {
  const $ = _c(13);
  const {
    image,
    name,
    size
  } = t0;
  let t1;
  if ($[0] !== name) {
    t1 = name.split(" ").map(_temp).join("");
    $[0] = name;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const initials = t1;
  let t2;
  if ($[2] !== size) {
    const sizeClasses = {
      xs: "h-8 w-8",
      sm: "h-10 w-10",
      md: "h-12 w-12",
      lg: "h-16 w-16"
    };
    t2 = cn("inline-flex aspect-square items-center justify-center rounded-full bg-gray-300", sizeClasses[size as keyof typeof sizeClasses]);
    $[2] = size;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== image) {
    t3 = image?.url ? {
      backgroundImage: `url(${getCdnUrl({
        src: image.url ?? ""
      })})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat"
    } : undefined;
    $[4] = image;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== image || $[7] !== initials) {
    t4 = !image && <span className="leading-none font-medium text-gray-700">{initials}</span>;
    $[6] = image;
    $[7] = initials;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <div className={t2} style={t3}>{t4}</div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
function _temp(n) {
  return n[0];
}